export const bindSubmitButton = (callback) => {
  const submitButton = document.getElementById("create-pswd-button");

  if (submitButton) {
    submitButton.onclick = (e) => {
      e.preventDefault();
      const new_pswd = document.getElementById('new_pswd').value;
      const confirm_pswd = document.getElementById('confirm_pswd').value;

      let form_input = { actions: {} };
      form_input['actions']['password'] = new_pswd;
      form_input['actions']['confirm_password'] = confirm_pswd;

      callback(form_input);
    };
  }
};